<template>
  <b-navbar toggleable="lg" type="light" variant="light">
    <b-navbar-brand>
      <Logo :logoProps="logo" />
    </b-navbar-brand>
    <b-navbar-nav v-if="$store.state.authToken">
      <b-nav-item to="/pri-searches-control-groups">Searches</b-nav-item>
      <!-- <b-nav-item-dropdown>
        <template v-slot:button-content>Simulation</template>

        <b-dropdown-item to="/pri-simulation">Single</b-dropdown-item>
      </b-nav-item-dropdown>-->
      <!-- <b-nav-item to="/pri-clients">Companies</b-nav-item> -->
      <!-- <b-nav-item-dropdown>
        <template v-slot:button-content>Searches</template>

        <b-dropdown-item to="/pri-searches">Single</b-dropdown-item>
        <b-dropdown-item to="/pri-searches-control-groups">Control Group</b-dropdown-item>
      </b-nav-item-dropdown>-->
      <b-nav-item to="/pri-settings/general-page">Settings</b-nav-item>

      <!-- <b-nav-item-dropdown>
        <template v-slot:button-content>
          Control Group Configuration
        </template>
       
        <b-dropdown-item to="/pri-control-group-categories">Categories</b-dropdown-item>
        <b-dropdown-item to="/pri-control-group-population">Population</b-dropdown-item>
      </b-nav-item-dropdown>-->
    </b-navbar-nav>

    <!-- Right aligned nav items -->
    <SideBar :right="true" :menus="availableMenus" />
    <b-navbar-nav class="ml-auto" v-if="$store.state.authToken">


      <!-- $store.state.form1.formDefaultLanguage ||  -->
      <b-nav-item-dropdown right >
        <!-- Using 'button-content' slot -->
        <template v-slot:button-content>
          <em>
            <font-awesome-icon icon="user" />
            {{nameToShow}}
          </em>
        </template>
        <!-- <b-dropdown-item href="#">Profile</b-dropdown-item> -->
        <b-dropdown-item @click="onLogout">{{$t('signOutBtnText')}}</b-dropdown-item>
      </b-nav-item-dropdown>
      <b-nav-form v-if="developerOnly == 1">
        <b-button variant="outline-info" size="sm" class="mr-2" @click="openDrawer">
          <font-awesome-icon icon="list" />
        </b-button>
      </b-nav-form>
    </b-navbar-nav>
  </b-navbar>
</template>
<script>
import { Helper } from "../../helpers";
import { EventBus } from "@/event-bus.js";
import uid from "uid";
import Layouts from "../../containers/layout";
import Logo from "../logo/logo.vue";
import SideBar from "../sidebar/sidebar.vue";
export default {
  name: "AppHeaderPri",
  components: {
    Layouts,
    Logo,
    SideBar
  },
  data() {
    return {
      developerOnly : process.env.VUE_APP_DEVEVLOPER_ONLY,
      logo: {
        width: "auto",
        height: "35px"
      },
      availableMenus: [
        {
          id: uid(),
          name: "Employee Page",
          path: "/employee-page",
          icon: "id-card"
        },
        {
          id: uid(),
          name: "Remediation Ogm",
          path: "/remediation-ogm",
          icon: "id-card"
        },
        {
          id: uid(),
          name: "Remediation",
          path: "/remediation",
          icon: "id-card"
        }
      ],

      globalLanguages: ["english", "spanish", "chinese"],
      // globalLanguages:[
      //   'english',
      //   'arabic',
      //   'chinese',
      //   'dutch',
      //   'french',
      //   'german',
      //   'hebrew',
      //   'indonesian',
      //   'japanese',
      //   'russian',
      //   'spanish',
      //   'swedish',
      //   'thai',
      // ],

      userGroupId: null,
      userFullName: null,
      userFirstName: null,
      userLastName: null,
      userEmail: null,
      nameToShow: null,
      formDefaultLanguage: "english"
    };
  },

  mounted() {
    this.userGroupId = localStorage.getItem("userGroupId");
    this.userFullName = localStorage.getItem("userFullname");
    this.userFirstName = localStorage.getItem("userFirstname");
    this.userLastname = localStorage.getItem("userLastname");
    this.userEmail = localStorage.getItem("userEmail");
    this.$store.state.authToken = localStorage.getItem("accessToken");
    this.$store.state.form1.formDefaultLanguage =
      localStorage.getItem("formDefaultLanguage") || "english";
    this.$store.state.selectedLanguage =
      localStorage.getItem("formDefaultLanguage") || "english";
    this.$i18n.locale =
      localStorage.getItem("formDefaultLanguage") || "english";
    this.formDefaultLanguage =
      localStorage.getItem("formDefaultLanguage") || "english";
    this.nameToShow =
      this.userFullName == "undefined"
        ? this.userFirstName + " " + this.userLastname
        : this.userFullName;
  },
  methods: {
    onUpdateLanguage(lang) {
      // console.log("onUpdateLanguage", lang);
      if (lang == "Chinese Simplified") {
        lang = "Chinese";
      }
      // this.$store.state.isLoading = true;
      let ll = lang.toLowerCase();
      let ff = this.$i18n.availableLocales.includes(ll); // checking selected languages with saved messages
      this.$i18n.locale = ff ? ll : "english";
      this.$store.state.form1.formDefaultLanguage = ff ? ll : "english";
      this.$store.state.selectedLanguage = ff ? ll : "english";
      localStorage.setItem("formDefaultLanguage", ff ? ll : "english");
      this.formDefaultLanguage = ff ? ll : "english";
      if (ll == "arabic" || ll == "hebrew") {
        this.$store.state.rightAlign = true;
      } else {
        this.$store.state.rightAlign = false;
      }
      //  setTimeout(() => {
      //   this.$store.state.isLoading = false;
      // }, 200);
    },
    onLogout() {
      localStorage.clear();
      this.$store.state.authToken = null;
      // localStorage.removeItem("accessToken");
      Helper.makeToast(this.$bvToast, "success", "Logout Success");
      //this.$router.replace("/login");
      if (process.env.VUE_APP_ENVIRONMENT == "development") {
        this.$router.replace("/login");
      } else if (process.env.VUE_APP_ENVIRONMENT == "production") {
        // console.log("url", process.env.VUE_APP_LOGIN_URL);
        window.location.href = process.env.VUE_APP_LOGIN_URL;
      }
    },

    openDrawer() {
      EventBus.$emit("onClickOpenHeaderDrawer", true);
    }
  }
};
</script>
<style scoped>
.capitalize {
  text-transform: capitalize;
}
</style>